import { render } from "./top-Header.vue?vue&type=template&id=0892b764&scoped=true"
import script from "./top-Header.vue?vue&type=script&lang=js"
export * from "./top-Header.vue?vue&type=script&lang=js"

import "./top-Header.vue?vue&type=style&index=0&id=0892b764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0892b764"]])

export default __exports__